import toast from "react-hot-toast";


const UseCopyText = () => {
    return (voucher: string): void => {
            toast.success("کپی شد", {position: "top-center"});
            navigator.clipboard.writeText(voucher)
    }
}

export  default  UseCopyText

